import React, { useEffect } from 'react';
import PageCarousel from '../components/PageCarousel';

function CallForChallenges() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const challengeInfo = [
    {
      title: 'Proposal Requirements',
      items: [
        'A suitable and attractive challenge title',
        'A brief introduction of the challenge (max 500 words)',
        'The impact and significance of the challenge in the research/industrial community',
        'Major rules for participation and evaluation criteria',
        'The organizing team (name, affiliation, email for each member)',
        'Important dates (submission deadline, data availability, etc.)',
        'Awards proposed, if any',
        'Any hands-on/live competition to be held during the event'
      ]
    },
    {
      title: 'Guidelines & Rules',
      items: [
        'Organizers cannot participate as competitors in their own challenge.',
        'Organizers must provide datasets: Training set (with GT) and Testing set (hidden GT).',
        'Organizers are responsible for evaluating results and maintaining leaderboards.',
        'Best teams may be invited for presentations, awards, or poster sessions at NCVPRIPG-2026.'
      ]
    }
  ];

  const importantDates = [
    { event: 'Challenges Proposal Submission Starts', date: 'January 7, 2026' },
    { 
      event: 'Challenges Proposal Submission Deadline', 
      oldDate: 'February 08, 2026',
      newDate: 'February 15, 2026'
    },
    { event: 'Notification of Accepted Challenges', date: 'February 16, 2026' },
    { event: 'Web Posting of Challenges', date: 'February 17, 2026' },
    { event: 'Opening Date for Submission to Challenges', date: 'February 24, 2026' },
    { event: 'Closing Date for Submission to Challenges', date: 'June 05, 2026' },
    { event: 'Announcement of Challenge Winners', date: 'June 20, 2026' },
    { event: 'Registration for Challenge Attendees', date: 'June 20 – July 05, 2026' }
  ];

  return (
    <div className="page-container">
      <PageCarousel />
      
      <section className="section-padding bg-white">
        <div className="container">
          {/* Header */}
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="section-title" style={{ fontWeight: 700, color: '#111' }}>Call for Challenges</h1>
              <div style={{ width: '80px', height: '4px', background: '#70b60a', margin: '15px auto' }}></div>
              <div className="col-lg-10 mx-auto mt-4 p-4 rounded" style={{ backgroundColor: '#f9fff0', borderLeft: '5px solid #70b60a' }}>
                <p className="mb-0 text-dark" style={{ textAlign: 'justify', lineHeight: '1.7' }}>
                  <strong>Note:</strong> Challenges should address a well-defined open problem relevant to NCVPRIPG-2026, provide high-quality data, and define a clear assessment procedure. We invite proposals for 3-hour challenge sessions addressing problems that will engage the research community.
                </p>
              </div>
            </div>
          </div>

          {/* Content Blocks */}
          <div className="row mb-5">
            <div className="col-lg-10 mx-auto">
              {challengeInfo.map((section, idx) => (
                <div key={idx} className="mb-5 p-4 bg-white shadow-sm border rounded">
                  <h3 className="mb-4" style={{ color: '#70b60a', fontWeight: 600, fontSize: '22px' }}>
                    {section.title}
                  </h3>
                  <div className="row">
                    {section.items.map((item, i) => (
                      <div key={i} className="col-12 d-flex align-items-start mb-3">
                        <i className="lni-check-mark-circle text-success mt-1 mr-3"></i>&nbsp;
                        <span style={{ fontSize: '16px', color: '#444' }}>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {/* Submission Note */}
              <div className="p-4 rounded border-dashed" style={{ border: '2px dashed #70b60a', backgroundColor: '#fff' }}>
                <h5 className="font-weight-bold mb-3">Submission Instructions</h5>
                <p>Submit your challenge proposals through Google Form</p>
                <div className="d-flex align-items-center mb-3">
                  <a href="https://docs.google.com/forms/d/e/1FAIpQLSeANSe3kE-PN22TaDYWMACXyCZYkXsDhwiRhbY2mTFUUpqqmA/viewform" className="font-weight-bold text-success">Click here to submit</a>
                </div>
                
              </div>
            </div>
          </div>

          {/* Timeline Section - Sabse Niche */}
          <div className="row mt-5">
            <div className="col-lg-10 mx-auto">
              <h3 className="mb-4" style={{ borderLeft: '5px solid #70b60a', paddingLeft: '15px', fontWeight: 600 }}>Challenges Organization Timeline</h3>
              <div className="table-responsive shadow-lg rounded" style={{ overflow: 'hidden' }}>
                <table className="table table-hover mb-0">
                  <thead style={{ background: '#70b60a', color: '#fff' }}>
                    <tr>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Event</th>
                      <th style={{ padding: '18px 25px', fontSize: '16px' }}>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importantDates.map((item, idx) => (
                      <tr key={idx} style={{ transition: 'all 0.2s' }}>
                        <td style={{ padding: '15px 25px', fontWeight: '500' }}>{item.event}</td>
                        <td style={{ padding: '15px 25px', color: '#70b60a', fontWeight: '700' }}>
                          {item.oldDate ? (
                            <>
                              <span style={{ textDecoration: 'line-through', marginRight: '8px', color: '#888', fontWeight: '500' }}>
                                {item.oldDate}
                              </span>
                              <span>{item.newDate}</span>
                            </>
                          ) : (
                            item.date
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="mt-4 text-center text-muted italic">
                * Organizers are encouraged to use open-source data licenses.
              </p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default CallForChallenges;